/*
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-07-06 09:52:50
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-07-30 16:46:19
 */
import { isEmpty } from '@/apisManage/utils'
export default {
  props: {
    apisDbList: {
      type: Array,
      default: () => {
        return []
      }
    },
    apisTableList: {
      type: Array,
      default: () => {
        return []
      }
    },
    apisConstList: {
      type: Array,
      default: () => {
        return []
      }
    },
    appList: {
      type: Array,
      default: () => {
        return []
      }
    },    
    selectCell: null
  },
  provide() {
    return {
      main: this
    }
  },
  methods: {
    // 加载常量分类
    loadConst() {
      this.apisConstList = []
      this.$http
        .get(`/pub/dm-const/listByCataCode?cataCode=APIS_SERVICE_TYPE`)
        .then(res => {
          if (res.code === 200) {
            this.apisConstList = res.data
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
        // 加载app
    loadApp() {
      this.appList = []
        let params = {
        }
        let query = {
          entity: {},
          orderItemList: []
        }
        this.$http
        .post('/app/list', JSON.stringify(query), { params: params })
        .then(res => {
          if (res.code === 200) {
            this.appList = res.data
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },     
    // 数据源
    loadAllDbs() {
      let params = {
        pageNum: 1,
        pageSize: 10
      }
      let query = {
        entity: {},
        orderItemList: [
          {
            asc: true,
            column: 'createTime'
          }
        ]
      }
      let self = this
      this.apisDbList = []
      this.$http
        .post(`/apis/db/queryAllDbs`, query, { params: params })
        .then(res => {
          if (res.code === 200) {
            if (!isEmpty(res.data.records)) {
              res.data.records.map(item => {
                self.apisDbList.push({
                  label: item.dbCode,
                  value: item.id
                })
              })
            }
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    // 表
    loadTables(id) {
      let self = this
      let params = {
        dataSourceId: id
      }
      self.apisTableList = []
      this.$http
        .get(`/apis/db/queryTable`, { params: params })
        .then(res => {
          if (res.code === 200) {
            if (!isEmpty(res.data)) {
              res.data.map(item => {
                self.apisTableList.push({
                  label: item.tbComment + '(' + item.tbName + ')',
                  value: item.tbName
                })
              })
            }
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    }
  }
}
